import React from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import AddUpdateUnitCard from "../Card/AddUpdateUnitCard";
import { useTemplateFontSettings } from "styles/templateFontSettings";

function AddUpdateUnitDialog({ onClose, open, afterUpdateFunc, selectedUnit, addAfterTable }) {
    
    return (
        <Dialog onClose={onClose} open={open} fullWidth maxWidth="lg">
            <DialogTitle>{selectedUnit ? 'Kurul/Kol/Komisyon Güncelle' : 'Kurul/Kol/Komisyon Ekle'}</DialogTitle>
            <DialogContent dividers>
                <AddUpdateUnitCard afterUpdateFunc={afterUpdateFunc} selectedUnit={selectedUnit} onClose={onClose} addAfterTable={addAfterTable} />
            </DialogContent>
            <DialogActions>
            </DialogActions>
        </Dialog>
    );
}

export default AddUpdateUnitDialog